import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

class DefaultShiftWithParamsForm extends Form {
  constructor(values: Record<string, string | number | boolean | null> = {}) {
    super(values, {
      id: 'number',
      title: 'string',
      start_at: 'string',
      end_at: 'string',
      extra_hours: 'boolean',
      color: 'string',
      overnight_shift: 'boolean',
      notes: 'string',
      work_area_id: 'string',
      location_id: 'string',
      is_selected: 'boolean',
    })

    makeObservable(this, {
      isSelected: computed,
    })
  }

  get isSelected(): boolean {
    return this.get('is_selected').value
  }

  get locationId(): number {
    return +this.get('location_id').value
  }

  get workAreaId(): number {
    return +this.get('work_area_id').value
  }
}

export default DefaultShiftWithParamsForm
